import { Box, Tab, Tabs } from "@mui/material";
import { type FC, useState } from "react";
import { FullScreenSidebar } from "../../../../../../generic/components/full-screen-sidebar";
import { PreviewDetailsSidebar } from "./preview-details-sidebar";
import { PreviewWithSidebar } from "./preview-with-sidebar/preview-with-sidebar";

type Tab = "preview" | "details";

export const PreviewSidebar: FC<{ open: boolean; isReview: boolean; fullHeight?: boolean }> = ({
  open,
  isReview,
  fullHeight,
}) => {
  const [tab, setTab] = useState<Tab>(isReview ? "details" : "preview");

  if (!open) return null;

  return (
    <FullScreenSidebar open={open} fullHeight={fullHeight} sx={{ m: 0 }}>
      <Box
        width="100%"
        sx={{
          px: 2,
          borderWidth: 1,
          borderColor: "grey.200",
          borderStyle: "solid",
        }}
      >
        <Tabs value={tab} onChange={(_, t) => setTab(t as Tab)}>
          <Tab label="Preview as..." value="preview" />
          <Tab label="Details" value="details" />
        </Tabs>
      </Box>
      {tab === "preview" && <PreviewWithSidebar />}
      {tab === "details" && <PreviewDetailsSidebar />}
    </FullScreenSidebar>
  );
};
